import {useEffect, useState} from 'react';
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {
    createFollowingUser,
    deleteFollowingUser,
    followingUser,
    USER_CURRENT_KEY,
    USER_FOLLOWER_KEY,
    USER_FOLLOWERS_KEY,
    USER_FOLLOWINGS_KEY,
    USER_RELATION_STATE_CIRCLE_KEY
} from "../api/public-voissa/users";
import useAbility from "./useAbility";
import useCurrentUserActionLocked, {ACTION_LOCKED} from "./useCurrentUserActionLocked";


const useProfileFollow = ({
        user,
        isRequest = true,
        follow = {},
    }) =>{

    const queryClient = useQueryClient();
    const currentUser = queryClient.getQueryData([USER_CURRENT_KEY]);
    const {can} = useAbility();
    const canFollow =  can({ action:'create', subject:'UserFollow' });
    const userId = user?._id;

    const [dataFollow, setDataFollow] = useState(follow);

    const {data : dataFollowApi, isFetched : isFetchedFollow} = useQuery(
        [USER_FOLLOWER_KEY, currentUser?._id, userId],
        ()=> followingUser(currentUser?._id, userId),
        {
            staleTime : (1000 * 60 * 5),
            enabled : !!currentUser?._id && isRequest,
        }
    );

    const {
        isLoading : isLoadingCreateFollowUser,
        mutate : mutateCreateFollowUser,
    } = useMutation(() => createFollowingUser(currentUser?._id, {userId}),{
        onSuccess: async (data) =>{
            await queryClient.invalidateQueries([USER_FOLLOWER_KEY, currentUser?._id, userId]);
            await queryClient.invalidateQueries([USER_FOLLOWINGS_KEY, userId]);
            await queryClient.invalidateQueries([USER_FOLLOWERS_KEY, userId]);
            await queryClient.invalidateQueries([USER_RELATION_STATE_CIRCLE_KEY, currentUser?._id, userId]);
            setDataFollow(data);
        }
    });

    const {
        isLoading : isLoadingDeleteFollowUser,
        mutate : mutateDeleteFollowUser,
    } = useMutation(() => deleteFollowingUser(currentUser?._id, dataFollow?.followId),{
        onSuccess: async () =>{
            await queryClient.invalidateQueries([USER_FOLLOWER_KEY, currentUser?._id, userId]);
            await queryClient.invalidateQueries([USER_FOLLOWINGS_KEY, userId]);
            await queryClient.invalidateQueries([USER_FOLLOWERS_KEY, userId]);
            await queryClient.invalidateQueries([USER_RELATION_STATE_CIRCLE_KEY, currentUser?._id, userId]);

            setDataFollow({isFollow : false, followId : null, isFollowBack : dataFollow.isFollowBack || false});
        }
    });

    // Utilisez useEffect pour réagir aux changements dans dataFollow
    useEffect(() => {
        if (dataFollowApi && isFetchedFollow) {
            setDataFollow(dataFollowApi);
        }
        // Cette dépendance s'assure que l'effet est exécuté chaque fois que dataFollow change
    }, [dataFollowApi, isFetchedFollow]);

    const isFollow = dataFollow?.isFollow || false;
    const isLoading = currentUser?._id && (isLoadingCreateFollowUser || isLoadingDeleteFollowUser || !isFetchedFollow);
    const isFollowBack = dataFollow?.isFollowBack || false;
    const followState = isFollowBack && !isFollow ? 2 : isFollow ? 1 : 0;

    const {handleLockedAction} = useCurrentUserActionLocked({action : ACTION_LOCKED.CREATE_FOLLOW, contentOwner : user});

    function handleFollow() {
        if(canFollow){
            if (isFollow) {mutateDeleteFollowUser();} else{ mutateCreateFollowUser();}
        }
        else {
            handleLockedAction();
            /*let isGenderGoToCertified = [2,3,4].includes(currentUser?.profile?.gender);
            switch (currentUser?.role) {
                case USER_ROLES.EMAIL_UNCONFIRMED:
                    openModal('EmailValidation', {toggle : true, isModal : true});
                break;
                case USER_ROLES.STANDARD:
                    if(isGenderGoToCertified){
                        navigate(createLink("userMeSettingsAbonnement"));
                    }
                    else{
                        openModal('ModalSubscription', {toggle : true});
                    }
                break;
                case USER_ROLES.CREATOR:
                    if(isGenderGoToCertified){
                        navigate(createLink("userMeSettingsAbonnement"));
                    }
                    else{
                        openModal('ModalSubscription', {toggle : true});
                    }
                break;
                case USER_ROLES.BANNED:

                break;
                default :
                    //openModal('EncourageSignup');
                    navigate(createLink("signin"));
            }*/
        }
    }

    return  {isFollow, isFollowBack, isLoading, followState, handleFollow };
};

export default useProfileFollow;